import script from "./Wait.vue?vue&type=script&setup=true&lang=ts"
export * from "./Wait.vue?vue&type=script&setup=true&lang=ts"

import "./Wait.vue?vue&type=style&index=0&id=c006a590&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c006a590"]])